import {
    DesignTokens,
    GivelifyButton,
    GivelifyLabel,
    GivelifyModal,
} from '@givelify/ui';
import { styled } from '@mui/material';

export const DragDescription = styled(GivelifyLabel)(({ theme }) => ({
    padding: theme.spacing(0, 2),
}));

export const SortModalFooter = styled('div')(({ theme }) => ({
    minHeight: 80,
    paddingRight: '80px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 90,
    boxShadow: '0px -1px 2px rgba(58, 76, 99, 0.2)',
}));

export const DoneButton = styled(GivelifyButton)(({ theme }) => ({
    height: 48,
    minHeight: 48,
    width: '170px',
    margin: 0,
    [theme.breakpoints.down('mobile')]: {
        fontSize: '16px',
    },
}));

export const CloseModal = styled('div')(({ theme }) => ({
    padding: theme.spacing(1),
    borderRight: '1px solid',
    borderRightColor: DesignTokens.color.dividerPrimaryDark,
}));

export const ModalHeader = styled('div')({
    display: 'flex',
    alignItems: 'center',
    boxShadow: DesignTokens.shadow.divider2,
});

export const ModalMobileTitle = styled(GivelifyLabel)(({ theme }) => ({
    paddingLeft: theme.spacing(1.5),
}));

export const SortModal = styled(GivelifyModal)(({ theme }) => ({
    '& .MuiPaper-root': {
        padding: 0,
        borderRadius: 0,
        maxWidth: '100%',
        width: '100%',
        height: '100%',
        maxHeight: '100%',
    },
}));

export const Content = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(3),
    height: '100%',
    '& .list': {
        '& > div': {
            padding: theme.spacing(0, 3),
            '& > div': {
                marginBottom: theme.spacing(3),
            },
        },
    },
}));
